module.exports = __webpack_public_path__ + "static/media/it.900c16b6.svg";